var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fade",class:_vm.className,attrs:{"id":_vm.id,"tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"backdrop"}),_c('div',{staticClass:"modal-dialog",class:`modal-${_vm.size}`,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }